// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.multiselect[data-v-dc789b2e], input[type='text'][data-v-dc789b2e] {\n\twidth: 100%;\n}\n.multiselect[data-v-dc789b2e] .multiselect__content-wrapper li>span,\n.multiselect[data-v-dc789b2e] .multiselect__single {\n\tdisplay: flex;\n\twhite-space: nowrap;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n}\n", ""]);
// Exports
module.exports = exports;
